import Vector from "../model/math/Vector";

const buffer = new ArrayBuffer(4);
const ui32 = new Uint32Array(buffer);
const f32 = new Float32Array(buffer);        

export default class Fast {
    constructor() {        
    }

    /**
     * @param {number} value 
     * @returns {number}
     */
    static floor(value) {
        // We need to handle negative numbers so that they floor towards negative infinity rather than towards 0.
        // We are flooring with bitwise operators, and they floor towards 0.
        if (value < 0) {
            const fv = -this.floorPositive(-value);

            // bitwise operators round towards 0. We need to subtract 1 if the value wasn't already an int.
            return value === fv ? fv : fv - 1;
        }
        else {
            return this.floorPositive(value);
        }
    }

    /**
     * @private
     * @param {number} value 
     * @returns {number}
     */
    static floorPositive(value) {
        // Values greater than 2147483647 cannot be cast to an int using the simple method.
        // Negative values would be ceil'd by the trick.
        if (value < 2147483648) {
            return value | 0;
        }
        else {
            return Math.floor(value);
        }
    }
    
    /**
     * Vector length.
     * @param {Vector} v 
     * @returns {number}
     */
    static len(v) {
        return 1.0 / this.invSqrt(v.x * v.x + v.y * v.y);
    }

    /**
     * Fast Normal.
     * @param {Vector} v 
     * @returns {Vector}
     */
    static nor(v) {
        const len = this.len(v);
        if (len != 0) {
            v.x /= len;
            v.y /= len;
        }
        return v;
    }

    /**
     * @param {Vector} v0 
     * @param {Vector} v1 
     * @returns {number}
     */
    static dist(v0, v1) {
        const dx = v0.x - v1.x;
        const dy = v0.y - v1.y;
        return 1.0 / this.invSqrt(dx * dx + dy * dy);
    }

    // From: https://gist.github.com/starfys/aaaee80838d0e013c27d

    /**
     * @param {number} x 
     * @returns {number}
     */
    static invSqrt(number) {
        f32[0] = number;
        ui32[0] = 0x5F3759DF - (ui32[0] >> 1);
        const x = f32[0];
        return x * (1.5 - 0.5 * x * x * number);
    }
}